import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductsWithSlide from "../ProductsWithSlide";
import { useSelector } from "react-redux";
import lang from "../../lang/lang";
import getImageUrl from "../../helpers/getImageUrl";
import styles from "./style.module.css";

export default function RelatedProducts() {
  const [activeCategory, setActiveCategory] = useState();
  const { relatedProducts, currentLanguage } = useSelector(({ main }) => main);

  useEffect(() => {
    setActiveCategory(relatedProducts?.related_categories?.[0]?.id);
  }, [relatedProducts]);

  return (
    <>
      {relatedProducts?.related_categories?.length &&
      Object.keys(relatedProducts?.related_categories_products || {})
        ?.length ? (
        <>
          <div className="wrapper">
            <h3 className={styles.title}>
              {lang[currentLanguage].similar_products}
            </h3>
            {window.innerWidth < 600 ? (
              <div className="scrollRow scrollBar">
                {relatedProducts?.related_categories.map((category, index) => {
                  if (
                    relatedProducts?.related_categories_products[category.id]
                      ?.length
                  )
                    return (
                      <SwiperSlide
                        className={`${styles.categoryItem} ${
                          category.id === activeCategory &&
                          styles.activeCategory
                        }`}
                        key={index}
                        onClick={() => setActiveCategory(category.id)}>
                        <div className={styles.imgBlock}>
                          <img
                            src={
                              getImageUrl(category?.icon) ||
                              "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3C/svg%3E"
                            }
                            alt={category["name_" + currentLanguage]}
                          />
                        </div>
                        <span>{category["name_" + currentLanguage]}</span>
                      </SwiperSlide>
                    );
                })}
              </div>
            ) : (
              <Swiper
                spaceBetween={20}
                slidesPerView={"auto"}>
                {relatedProducts?.related_categories.map((category, index) => {
                  if (
                    relatedProducts?.related_categories_products[category.id]
                      ?.length
                  )
                    return (
                      <SwiperSlide
                        className={`${styles.categoryItem} ${
                          category.id === activeCategory &&
                          styles.activeCategory
                        }`}
                        key={index}
                        onClick={() => setActiveCategory(category.id)}>
                        <div className={styles.imgBlock}>
                          <img
                            src={
                              getImageUrl(category?.icon) ||
                              "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='2'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3C/svg%3E"
                            }
                            alt={category["name_" + currentLanguage]}
                          />
                        </div>
                        <span>{category["name_" + currentLanguage]}</span>
                      </SwiperSlide>
                    );
                })}
              </Swiper>
            )}
          </div>

          {relatedProducts?.related_categories_products[activeCategory]
            ?.length ? (
            <ProductsWithSlide
              productsData={relatedProducts?.related_categories_products[activeCategory]}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
}
